import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { MapService } from 'lib';
import { environment } from '../../../../../environments/environment';
import { loadModules } from 'esri-loader';

@Component({
  selector: 'web-printer',
  templateUrl: './printer.component.html',
  styleUrls: ['./printer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrinterComponent implements OnInit, OnDestroy {
  @ViewChild('element', { static: true }) element: ElementRef<HTMLDivElement>;
  private printer: __esri.Print;
  private subcribe: Subscription;
  constructor(
    private mapService: MapService
  ) { }

  ngOnInit() {
    this.subcribe = this.mapService.loaded$.subscribe(async loaded => {
      if (loaded) {
        const [Print] = await loadModules(['esri/widgets/Print']);
        this.printer = new Print({
          view: this.mapService.view,
          container: this.element.nativeElement,
          printServiceUrl: environment.map.printService
        });
      }
    });
  }

  ngOnDestroy() {
    this.subcribe.unsubscribe();
  }

  handleBtnOption() {
  }

}
